// Do not edit directly, this file was auto-generated.

export default {
  IDSmetadata: {
    exportTimestamp: 'Tue, 21 Apr 2026 23:48:57 GMT',
    figmaLastUpdated: 'Tue, 21 Apr 2026 23:27:32 GMT',
    format: 'javascript-esm-react',
    measurementUnits: 'px',
    relatedThemeName: 'none',
    styleDictionaryVersion: '4.4.0',
    targetPlatform: 'all',
    themeName: 'Patient Dark',
    tokensetVersion: '1.49.0',
    typographySetName: 'functionalTypography-Core',
  },
  accordion: {
    default: {
      color: {
        body: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#292c32',
            pressed: '#292c32',
          },
          text: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
        decorative: {
          accent: '#03b3c9',
          decorative1: '#99c4ff',
          decorative2: '#ffd499',
          decorative3: '#ecacdf',
          decorative4: '#99e3ff',
          decorative5: '#99fff9',
          error: '#ff9999',
          neutral: '#d4d5d8',
          success: '#99ffaa',
          warning: '#6e5008',
        },
        divider: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#383b42',
          pressed: '#484a51',
        },
        expanded: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#292c32',
          },
        },
        header: {
          collapsed: {
            background: {
              disabled: 'rgba(12,15,24,0.48)',
              enabled: '#0c0f18',
              focus: '#0c0f18',
              hover: '#171b26',
              pressed: '#292c32',
            },
          },
          text: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
        sublabel: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
      },
      radius: {
        body: '0',
        header: '0',
      },
      spacing: {
        expandCollapseAllGap: {
          groupGap: '16px',
        },
        small: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '8px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '4px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '8px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
        standard: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '12px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '12px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '16px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '8px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '12px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '12px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
      },
    },
  },
  autocomplete: {
    default: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
    error: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
  },
  avatar: {
    default: {
      color: {
        background: '#0c0f18',
        border: {
          enabled: '#61636b',
          focus: '#61636b',
          hover: '#7dcde8',
          pressed: '#b2e4f5',
        },
        content: '#e2e2e4',
        focusOutline: '#fafeff',
        hover: 'rgba(0,0,0,0)',
        hoverOutline: '#7dcde8',
      },
      radius: '9999px',
      sizing: {
        large: '64px',
        medium: '48px',
        small: '40px',
        xl: '120px',
        xs: '24px',
      },
    },
  },
  badge: {
    default: {
      color: {
        background: {
          accent: '#03b3c9',
          brand: '#7dcde8',
          decorative1: '#99c4ff',
          decorative2: '#ffd499',
          decorative3: '#ecacdf',
          decorative4: '#99e3ff',
          decorative5: '#99fff9',
          default: {
            accent: '#03b3c9',
            brand: '#7dcde8',
            decorative1: '#99c4ff',
            decorative2: '#ffd499',
            decorative3: '#ecacdf',
            decorative4: '#99e3ff',
            decorative5: '#99fff9',
            neutral: '#d4d5d8',
          },
          dot: '#03b3c9',
          inverse: {
            accent: '#027285',
            brand: '#0f4557',
            decorative1: '#004199',
            decorative2: '#995900',
            decorative3: '#7c1d68',
            decorative4: '#004a66',
            decorative5: '#004d48',
            neutral: '#292c32',
            neutralInverse: '#292c32',
          },
          neutral: '#292c32',
          neutralInverse: '#d4d5d8',
          pill: '#03b3c9',
        },
        border: {
          default: '#fcfcfd',
          defaultInverse: '#292c32',
        },
        label: {
          default: '#fcfcfd',
          defaultInverse: '#292c32',
          pill: '#ffffff',
        },
      },
      radius: {
        dot: '9999px',
        pill: '9999px',
      },
      spacing: {
        standard: {
          min: {
            dotHeight: '20px',
            dotWidth: '20px',
            pillHeight: '20px',
            pillWidth: '20px',
          },
          padding: {
            bottom: '2px',
            left: '4px',
            right: '4px',
            top: '2px',
          },
        },
      },
    },
  },
  banner: {
    default: {
      color: {
        background: '#d4d5d8',
        icon: '#292c32',
        text: '#292c32',
        textLink: {
          disabled: {
            icon: 'rgba(41,44,50,0.48)',
            text: 'rgba(41,44,50,0.48)',
          },
          enabled: {
            icon: '#292c32',
            text: '#292c32',
          },
          focused: {
            icon: '#292c32',
            text: '#292c32',
          },
          hover: {
            icon: '#171b26',
            text: '#171b26',
          },
          outline: '#041116',
          pressed: {
            icon: '#0c0f18',
            text: '#0c0f18',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    error: {
      color: {
        background: '#ff9999',
        icon: '#292c32',
        text: '#292c32',
        textLink: {
          disabled: {
            icon: 'rgba(41,44,50,0.48)',
            text: 'rgba(41,44,50,0.48)',
          },
          enabled: {
            icon: '#292c32',
            text: '#292c32',
          },
          focused: {
            icon: '#292c32',
            text: '#292c32',
          },
          hover: {
            icon: '#171b26',
            text: '#171b26',
          },
          outline: '#041116',
          pressed: {
            icon: '#0c0f18',
            text: '#0c0f18',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    warning: {
      color: {
        background: '#f4c65a',
        icon: '#292c32',
        text: '#292c32',
        textLink: {
          disabled: {
            icon: 'rgba(226,226,228,0.48)',
            text: 'rgba(226,226,228,0.48)',
          },
          enabled: {
            icon: '#e2e2e4',
            text: '#e2e2e4',
          },
          focused: {
            icon: '#e2e2e4',
            text: '#e2e2e4',
          },
          hover: {
            icon: '#efeff0',
            text: '#efeff0',
          },
          outline: '#fafeff',
          pressed: {
            icon: '#fcfcfd',
            text: '#fcfcfd',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
  },
  blade: {
    default: {
      color: {
        border: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          hover: '#b2e4f5',
          iconButton: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
          },
          nonscrolling: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          pressed: '#f1fbfe',
          scrolling: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        borderDefault: '#61636b',
        button: {
          enabled: '#7dcde8',
          focus: '#fafeff',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
        container: {
          default: '#292c32',
          enabled: 'rgba(125,205,232,0)',
          hover: 'rgba(125,205,232,0.08)',
          pressed: 'rgba(125,205,232,0.16)',
        },
        content: {
          copy: '#e2e2e4',
          label: '#e2e2e4',
          sublabel: '#e2e2e4',
        },
        copy: '#e2e2e4',
        label: '#e2e2e4',
        sublabel: '#e2e2e4',
      },
      sizing: {
        GapMedium: '8px',
        GapSmall: '8px',
        MaxWidthCollapsed: '40px',
        MinWidthExpanded: '320px',
        PaddingHorizontal: '24px',
        PaddingLabelsBottom: '2px',
        PaddingVertical: '16px',
      },
      spacing: {
        GapLarge: '24px',
        GapMedium: '16px',
        GapSmall: '8px',
        PaddingHorizontal: '24px',
        PaddingTitlesBottom: '2px',
        PaddingVertical: '16px',
      },
    },
  },
  breadcrumbs: {
    default: {
      color: {
        current: '#e2e2e4',
        separator: '#d4d5d8',
      },
      sizing: {
        separator: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        padding: {
          gap: '4px',
        },
      },
    },
  },
  button: {
    default: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(125,205,232,0)',
            enabled: 'rgba(125,205,232,0)',
            focus: 'rgba(125,205,232,0)',
            hover: 'rgba(125,205,232,0.08)',
            pressed: 'rgba(125,205,232,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        outline: '#fafeff',
        primary: {
          background: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          outline: '#fafeff',
          shadow: {
            enabled: 'rgba(0,94,148,0.32)',
            hover: 'rgba(178,228,245,0.32)',
            pressed: 'rgba(241,251,254,0.32)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(125,205,232,0)',
            enabled: 'rgba(125,205,232,0)',
            focus: 'rgba(125,205,232,0)',
            hover: 'rgba(125,205,232,0.08)',
            pressed: 'rgba(125,205,232,0.16)',
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          content: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#0c0f18',
            focus: '#0c0f18',
            hover: 'rgba(125,205,232,0.08)',
            pressed: 'rgba(125,205,232,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    error: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(255,153,153,0)',
            enabled: 'rgba(255,153,153,0)',
            focus: 'rgba(255,153,153,0)',
            hover: 'rgba(255,153,153,0.08)',
            pressed: 'rgba(255,153,153,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ff9999',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
        },
        outline: '#fafeff',
        primary: {
          background: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ff9999',
            hover: '#ffb2b2',
            pressed: '#fcebeb',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          shadow: {
            enabled: 'rgba(255,153,153,0.40)',
            hover: 'rgba(255,153,153,0.48)',
            pressed: 'rgba(255,153,153,0.56)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(255,153,153,0)',
            enabled: 'rgba(255,153,153,0)',
            focus: 'rgba(255,153,153,0)',
            hover: 'rgba(255,153,153,0.08)',
            pressed: 'rgba(255,153,153,0.16)',
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
          content: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ff9999',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#0c0f18',
            focus: '#0c0f18',
            hover: 'rgba(255,153,153,0.08)',
            pressed: 'rgba(255,153,153,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ff9999',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColor: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(125,205,232,0)',
            enabled: 'rgba(125,205,232,0)',
            focus: 'rgba(125,205,232,0)',
            hover: 'rgba(125,205,232,0.40)',
            pressed: 'rgba(125,205,232,0.48)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        outline: '#041116',
        primary: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#383b42',
            pressed: '#484a51',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          shadow: {
            enabled: 'rgba(212,213,216,0)',
            hover: 'rgba(212,213,216,0)',
            pressed: 'rgba(212,213,216,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(212,213,216,0)',
            enabled: 'rgba(212,213,216,0)',
            focus: 'rgba(212,213,216,0)',
            hover: 'rgba(212,213,216,0.08)',
            pressed: 'rgba(212,213,216,0.16)',
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#383b42',
            pressed: '#484a51',
          },
          content: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          outline: '#fafeff',
        },
        tertiary: {
          background: {
            disabled: 'rgba(252,252,253,0.24)',
            enabled: 'rgba(252,252,253,0.40)',
            focus: 'rgba(252,252,253,0.40)',
            hover: 'rgba(125,205,232,0.40)',
            pressed: 'rgba(125,205,232,0.56)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColorInverse: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(15,69,87,0)',
            enabled: 'rgba(15,69,87,0)',
            focus: 'rgba(15,69,87,0)',
            hover: 'rgba(15,69,87,0.40)',
            pressed: 'rgba(15,69,87,0.48)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        outline: '#fafeff',
        primary: {
          background: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#d4d5d8',
            hover: '#e2e2e4',
            pressed: '#efeff0',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(15,69,87,0.48)',
            enabled: '#0f4557',
            focus: '#0f4557',
            hover: '#08232c',
            pressed: '#041116',
          },
          shadow: {
            enabled: 'rgba(212,213,216,0)',
            hover: 'rgba(212,213,216,0)',
            pressed: 'rgba(212,213,216,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(41,44,50,0)',
            enabled: 'rgba(41,44,50,0)',
            focus: 'rgba(41,44,50,0)',
            hover: 'rgba(15,69,87,0.40)',
            pressed: 'rgba(15,69,87,0.48)',
          },
          border: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#d4d5d8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          content: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
          outline: '#fafeff',
        },
        tertiary: {
          background: {
            disabled: 'rgba(41,44,50,0.16)',
            enabled: 'rgba(41,44,50,0.56)',
            focus: 'rgba(12,15,24,0.48)',
            hover: 'rgba(15,69,87,0.72)',
            pressed: 'rgba(15,69,87,0.80)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    success: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(153,255,170,0)',
            enabled: 'rgba(153,255,170,0)',
            focus: 'rgba(153,255,170,0)',
            hover: 'rgba(153,255,170,0.08)',
            pressed: 'rgba(153,255,170,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(153,255,170,0.48)',
            enabled: '#99ffaa',
            focus: '#99ffaa',
            hover: '#b2ffbf',
            pressed: '#ccffd4',
          },
        },
        outline: '#fafeff',
        primary: {
          background: {
            disabled: 'rgba(153,255,170,0.48)',
            enabled: '#99ffaa',
            focus: '#99ffaa',
            hover: '#b2ffbf',
            pressed: '#ccffd4',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          shadow: {
            enabled: 'rgba(153,255,170,0.40)',
            hover: 'rgba(153,255,170,0.48)',
            pressed: 'rgba(153,255,170,0.56)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(153,255,170,0)',
            enabled: 'rgba(153,255,170,0)',
            focus: 'rgba(153,255,170,0)',
            hover: 'rgba(153,255,170,0.08)',
            pressed: 'rgba(153,255,170,0.16)',
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#b2ffbf',
            pressed: '#ccffd4',
          },
          content: {
            disabled: 'rgba(153,255,170,0.48)',
            enabled: '#99ffaa',
            focus: '#99ffaa',
            hover: '#b2ffbf',
            pressed: '#ccffd4',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#0c0f18',
            focus: '#0c0f18',
            hover: 'rgba(153,255,170,0.08)',
            pressed: 'rgba(153,255,170,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(153,255,170,0.48)',
            enabled: '#99ffaa',
            focus: '#99ffaa',
            hover: '#b2ffbf',
            pressed: '#ccffd4',
          },
        },
      },
      radius: {
        small: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
        standard: {
          discreet: '9999px',
          primary: '9999px',
          secondary: '9999px',
          tertiary: '9999px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '24px',
              width: '24px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '48px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
  },
  card: {
    default: {
      color: {
        border: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#fafeff',
          hover: '#383b42',
          pressed: '#484a51',
        },
        container: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          hover: '#383b42',
          pressed: '#484a51',
        },
        contentBackground: '#0c0f18',
        danger: '#ff9999',
        dataViz: {
          solid: '#99c4ff',
          transparent: 'rgba(153,196,255,0.32)',
        },
        decorative1: '#99c4ff',
        decorative2: '#ffd499',
        decorative3: '#ecacdf',
        decorative4: '#99e3ff',
        decorative5: '#99fff9',
        icon: '#03b3c9',
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        neutral: '#d4d5d8',
        sublabel: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
        success: '#99ffaa',
        warning: '#f4c65a',
      },
      radius: '12px',
      spacing: {
        body: {
          content: {
            padding: {
              bottom: '16px',
              gap: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        footer: {
          actions: {
            bottom: '0',
            gap: '8px',
            left: '0',
            right: '0',
            top: '0',
          },
          padding: {
            bottom: '16px',
            gap: '16px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
        },
        header: {
          content: {
            padding: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
          },
          leading: {
            padding: {
              bottom: '0',
              gap: '8px',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          trailing: {
            padding: {
              bottom: '16px',
              gap: '8px',
              left: '0',
              right: '16px',
              top: '16px',
            },
          },
        },
        padding: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chatBubble: {
    default: {
      color: {
        reply: {
          background: '#292c32',
          senderLabel: '#292c32',
          text: '#e2e2e4',
        },
        user: {
          background: '#027285',
          senderLabel: '#292c32',
          text: '#e2e2e4',
        },
      },
      radius: {
        reply: {
          bottomLeft: '4px',
          bottomRight: '24px',
          topLeft: '24px',
          topRight: '24px',
        },
        user: {
          bottomLeft: '24px',
          bottomRight: '4px',
          topLeft: '24px',
          topRight: '24px',
        },
      },
      spacing: {
        footer: {
          actions: {
            gap: '4px',
          },
          gap: '8px',
          top: '4px',
        },
        reply: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        replyWithContent: {
          avatar: {
            bottom: '12px',
            left: '16px',
            right: '16px',
            top: '24px',
          },
          default: {
            bottom: '8px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
          suggestion: {
            actions: {
              bottom: '0',
              gap: '8px',
              left: '16px',
              right: '16px',
              top: '0',
            },
            container: {
              bottom: '24px',
              gap: '16px',
              left: '0',
              right: '0',
              top: '12px',
            },
            header: {
              bottom: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
        },
        user: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
      },
    },
  },
  chatInputField: {
    default: {
      color: {
        scrollbar: 'rgba(212,213,216,0.16)',
        sendButton: {
          disabled: 'rgba(125,205,232,0.48)',
          enabled: '#7dcde8',
        },
      },
      radius: {
        actions: {
          bottomLeft: '24px',
          bottomRIght: '24px',
          topLeft: '0',
          topRight: '0',
        },
        focus: '24px',
        input: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '24px',
          topRight: '24px',
        },
      },
      spacing: {
        actions: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '8px',
          top: '8px',
        },
        input: {
          bottom: '12px',
          left: '16px',
          right: '16px',
          top: '12px',
        },
      },
    },
  },
  chatbot: {
    default: {
      body: {
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          leftSlot: {
            bottom: '8px',
            gap: '0',
            left: '24px',
            progressIndicator: {
              padding: '0',
            },
            right: '72px',
            top: '8px',
          },
          rightSlot: {
            bottom: '8px',
            gap: '0',
            left: '72px',
            right: '24px',
            top: '8px',
          },
        },
      },
      container: {
        radius: {
          bottomLeft: '24px',
          bottomRight: '4px',
          topLeft: '24px',
          topRight: '24px',
        },
        shadow: {
          blur: '24px',
          color: 'rgba(87,87,87,0.16)',
          spread: '2px',
          x: '0',
          y: '8px',
        },
        sizing: {
          minHeight: '600px',
          minWidth: '600px',
        },
      },
      fab: {
        color: {
          border: 'rgba(255,255,255,0.48)',
          state: {
            disabled: 'rgba(13,13,13,0)',
            enabled: 'rgba(13,13,13,0)',
            focus: 'rgba(13,13,13,0)',
            hover: 'rgba(13,13,13,0.16)',
            pressed: 'rgba(13,13,13,0.32)',
          },
        },
        radius: {
          bottomLeft: '24px',
          bottomRight: '4px',
          topLeft: '24px',
          topRight: '24px',
        },
        spacing: {
          left: '8px',
        },
      },
      footer: {
        color: {
          background: 'rgba(153,0,89,0.72)',
          disclaimer: {
            text: {
              enabled: '#292c32',
            },
            textLink: {
              disabled: 'rgba(41,44,50,0.48)',
              enabled: '#292c32',
              focus: '#292c32',
              focusOutline: '#041116',
              hover: '#171b26',
              pressed: '#0c0f18',
            },
          },
        },
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          bottom: '8px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '16px',
        },
      },
      gradient: {
        end: '#03b3c9',
        start: '#99c4ff',
      },
      header: {
        color: {
          background: 'rgba(37,0,86,0.72)',
          border: 'rgba(255,255,255,0.48)',
          title: '#292c32',
        },
        spacing: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          rightIcons: {
            gap: '8px',
          },
          top: '16px',
        },
      },
    },
  },
  checkbox: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(125,205,232,0.48)',
              enabled: '#7dcde8',
              focus: '#7dcde8',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
            unselected: {
              disabled: 'rgba(125,205,232,0)',
              enabled: 'rgba(125,205,232,0)',
              focus: 'rgba(125,205,232,0)',
              hover: 'rgba(125,205,232,0.08)',
              pressed: 'rgba(125,205,232,0.16)',
            },
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        help: {
          enabled: '#d4d5d8',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#fafeff',
      },
      radius: {
        control: '4px',
        focus: '12px',
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(255,153,153,0.48)',
              enabled: '#ff9999',
              focus: '#ff9999',
              hover: '#ffb2b2',
              pressed: '#fcebeb',
            },
            unselected: {
              disabled: 'rgba(255,153,153,0)',
              enabled: 'rgba(255,153,153,0)',
              focus: 'rgba(255,153,153,0)',
              hover: 'rgba(255,153,153,0.08)',
              pressed: 'rgba(255,153,153,0.16)',
            },
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#ff9999',
            focus: '#ff9999',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        help: {
          enabled: '#ff9999',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#fafeff',
      },
      radius: {
        control: '4px',
        focus: '12px',
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chip: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          unselected: {
            disabled: 'rgba(125,205,232,0)',
            enabled: 'rgba(125,205,232,0)',
            focus: 'rgba(125,205,232,0)',
            hover: 'rgba(125,205,232,0.08)',
            pressed: 'rgba(125,205,232,0.16)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          unselected: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        icon: {
          selected: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          unselected: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        label: {
          selected: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          unselected: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        outline: '#fafeff',
      },
      radius: {
        small: '9999px',
        standard: '9999px',
      },
      sizing: {
        small: {
          height: '24px',
          icon: '24px',
        },
        standard: {
          height: '40px',
          icon: '24px',
        },
      },
      spacing: {
        group: {
          gap: '8px',
        },
        small: {
          bottom: '2px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '4px',
            right: '4px',
          },
          left: '2px',
          right: '2px',
          top: '2px',
        },
        standard: {
          bottom: '4px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '8px',
            right: '8px',
          },
          left: '4px',
          right: '4px',
          top: '4px',
        },
      },
    },
  },
  columnSettingsMenu: {
    default: {
      color: {
        background: {
          default: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#383b42',
            pressed: '#0f4557',
          },
          frozen: {
            disabled: 'rgba(12,15,24,0.48)',
            enabled: '#0c0f18',
            focus: '#0c0f18',
            hover: '#171b26',
            pressed: '#292c32',
          },
        },
        border: {
          frozenUnchecked: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#484a51',
            pressed: '#383b42',
          },
        },
        focusOutline: '#fafeff',
        icon: {
          disabled: 'rgba(153,153,153,0.48)',
          enabled: '#999999',
          focus: '#999999',
          hover: '#777777',
          pressed: '#555555',
        },
        label: {
          default: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
          frozen: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#d4d5d8',
            hover: '#e2e2e4',
            pressed: '#efeff0',
          },
        },
        outline: '#fafeff',
      },
      height: {
        leadingIcon: '21px',
      },
      padding: {
        freezeLine: {
          right: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '24px',
          top: '8px',
        },
      },
      radius: {
        cell: '0',
        column: '12px',
        focusOutline: '12px',
      },
      strokeWidth: {
        focusOutline: '2px',
      },
    },
  },
  control: {
    default: {
      color: {
        focus: '#000000',
      },
    },
    error: {
      color: {
        focus: '#000000',
      },
    },
  },
  datePicker: {
    default: {
      color: {
        calendar: {
          border: '#292c32',
          container: '#292c32',
        },
        dayOption: {
          badgeEnabled: '#7dcde8',
          badgeHover: '#b2e4f5',
          badgeSelected: '#ffffff',
          fillEnabled: '#292c32',
          fillEnabledHover: '#ffffff',
          fillSelected: '#7dcde8',
          fillSelectedHover: '#b2e4f5',
          todayEnabled: '#d4d5d8',
          todayHover: '#e2e2e4',
          todaySelected: '#ffffff',
        },
        option: {
          badgeEnabled: '#7dcde8',
          badgeHover: '#b2e4f5',
          badgeSelected: '#0f4557',
          fillEnabled: '#292c32',
          fillEnabledHover: '#002d47',
          fillSelected: '#7dcde8',
          fillSelectedHover: '#b2e4f5',
          todayEnabled: '#d4d5d8',
          todayHover: '#e2e2e4',
          todaySelected: '#0f4557',
        },
        typography: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          hover: '#efeff0',
          selected: '#292c32',
          static: '#d4d5d8',
        },
      },
      minWidth: '104px',
      radius: {
        option: '9999px',
      },
      sizing: {
        containerMinWidth: '320px',
        dayMaxHeight: '48px',
        dayMaxWidth: '48px',
        dialogMaxHeight: '392px',
        dialogMinWidth: '320px',
        optionMaxHeight: '40px',
        optionMinWidth: '64px',
        small: {
          minWidth: '97px',
        },
        standard: {
          minWidth: '114px',
        },
      },
      spacing: {
        calendarGap: '8px',
        dialogPadding: '16px',
        optionRowGap: '16px',
        small: {
          textGap: '4px',
        },
        standard: {
          textGap: '8px',
        },
      },
    },
  },
  divider: {
    default: {
      color: {
        dark: '#d4d5d8',
        light: '#292c32',
        medium: '#61636b',
        semiOpaque: 'rgba(255,255,255,0.48)',
      },
    },
  },
  dragAndDrop: {
    default: {
      background: 'rgba(12,15,24,0.40)',
    },
  },
  fab: {
    default: {
      radius: {
        bottomLeft: '9999px',
        bottomRight: '9999px',
        topLeft: '9999px',
        topRight: '9999px',
      },
      shadow: {
        blur: '24px',
        color: 'rgba(87,87,87,0.16)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      sizing: {
        label: {
          min: {
            width: '64px',
          },
        },
        noLabel: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  fileUploader: {
    default: {
      color: {
        dropZone: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#002d47',
            pressed: '#041116',
          },
          border: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#d4d5d8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          content: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#ff9999',
          },
          iconSuccess: {
            enabled: '#99ffaa',
          },
          text: {
            enabled: '#e2e2e4',
          },
        },
        help: {
          enabled: '#d4d5d8',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '12px',
      },
    },
    error: {
      color: {
        dropZone: {
          background: {
            disabled: '#990000',
            enabled: '#990000',
            focus: '#990000',
            hover: '#990000',
            pressed: '#990000',
          },
          border: {
            disabled: '#ffb2b2',
            enabled: '#ffb2b2',
            focus: '#ffb2b2',
            hover: '#ffb2b2',
            pressed: '#ffb2b2',
          },
          content: {
            disabled: '#ffb2b2',
            enabled: '#ffb2b2',
            focus: '#ffb2b2',
            hover: '#ffb2b2',
            pressed: '#ffb2b2',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#ff9999',
          },
          iconSuccess: {
            enabled: '#99ffaa',
          },
          text: {
            enabled: '#e2e2e4',
          },
        },
        help: {
          enabled: '#d4d5d8',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '12px',
      },
    },
  },
  floatingActionColumn: {
    default: {
      border: {
        color: '#484a51',
        stroke: '1px',
      },
      padding: {
        gap: '0',
        horizontal: '0',
        vertical: '0',
      },
      radius: {
        radius: '0',
      },
      shadow: {
        blur: '20px',
        color: 'rgba(87,87,87,0.16)',
        spread: '0',
        x: '-8px',
        y: '0',
      },
    },
  },
  footer: {
    default: {
      color: {
        content: '#e2e2e4',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
    defaultInverse: {
      color: {
        content: '#292c32',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
  },
  functional: {
    borderWidth: {
      focus: {
        default: '2px',
      },
    },
    color: {
      border: {
        accent: {
          disabled: 'rgba(3,179,201,0.48)',
          enabled: '#03b3c9',
          hover: '#dbfbff',
          pressed: '#e5fcff',
        },
        brand: {
          disabled: 'rgba(125,205,232,0.48)',
          enabled: '#7dcde8',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
        danger: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        default: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          hover: '#484a51',
          pressed: '#383b42',
        },
        'default-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        defaultInverse: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
        focus: '#fafeff',
        'focus-inverse': '#ffffff',
        focusInverse: '#041116',
        subtle: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          hover: '#383b42',
          pressed: '#484a51',
        },
        success: {
          disabled: 'rgba(153,255,170,0.48)',
          enabled: '#99ffaa',
          hover: '#b2ffbf',
          pressed: '#ccffd4',
        },
        transparent: 'rgba(255,255,255,0)',
        warning: {
          disabled: 'rgba(244,198,90,0.48)',
          enabled: '#f4c65a',
          hover: '#f7d991',
          pressed: '#fbecc8',
        },
        white: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
      },
      content: {
        accent: {
          disabled: 'rgba(3,179,201,0.48)',
          enabled: '#03b3c9',
          hover: '#027285',
          pressed: '#015965',
        },
        'accent-inverse': {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: 'rgba(230,230,230,1)',
          hover: 'rgba(230,230,230,1)',
          pressed: 'rgba(230,230,230,1)',
        },
        accentInverse: {
          disabled: 'rgba(2,114,133,0.48)',
          enabled: '#027285',
          hover: '#015965',
          pressed: '#012d33',
        },
        brand: {
          disabled: 'rgba(125,205,232,0.48)',
          enabled: '#7dcde8',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
        'brand-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        brandInverse: {
          disabled: 'rgba(15,69,87,0.48)',
          enabled: '#0f4557',
          hover: '#08232c',
          pressed: '#041116',
        },
        danger: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        'danger-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        dangerInverse: {
          disabled: 'rgba(153,0,0,0.48)',
          enabled: '#990000',
          hover: '#660000',
          pressed: '#330000',
        },
        default: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        'default-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        defaultInverse: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          hover: '#171b26',
          pressed: '#0c0f18',
        },
        subtle: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
        'subtle-inverse': {
          disabled: '#ffffff',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtleInverse: {
          disabled: 'rgba(56,59,66,0.48)',
          enabled: '#383b42',
          hover: '#292c32',
          pressed: '#171b26',
        },
        success: {
          disabled: 'rgba(153,255,170,0.48)',
          enabled: '#99ffaa',
          hover: '#b2ffbf',
          pressed: '#ccffd4',
        },
        'success-inverse': {
          disabled: 'rgba(255,255,255,0)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        successInverse: {
          disabled: 'rgba(0,69,11,0.48)',
          enabled: '#005e0f',
          hover: '#00450b',
          pressed: '#001a04',
        },
        warning: {
          disabled: 'rgba(102,78,0,0.48)',
          enabled: '#6e5008',
          hover: '#523b04',
          pressed: '#0f0b00',
        },
        'warning-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        warningInverse: {
          disabled: 'rgba(244,198,90,0.48)',
          enabled: '#f4c65a',
          hover: '#f7d991',
          pressed: '#fbecc8',
        },
      },
      dataViz: {
        content: {
          axis: '#808080',
          label: '#4d4d4d',
          title: {
            enabled: '#333333',
            hover: '#2e2e2e',
            pressed: '#292929',
          },
        },
        five: {
          enabled: '#005587',
          hover: '#005587',
          pressed: '#005587',
        },
        four: {
          enabled: '#028217',
          hover: '#028217',
          pressed: '#028217',
        },
        gray: {
          enabled: '#bfbfbf',
          hover: '#bfbfbf',
          pressed: '#bfbfbf',
        },
        one: {
          enabled: '#9e54b0',
          hover: '#9e54b0',
          pressed: '#9e54b0',
        },
        six: {
          enabled: '#d18100',
          hover: '#d18100',
          pressed: '#d18100',
        },
        three: {
          enabled: '#df216d',
          hover: '#df216d',
          pressed: '#df216d',
        },
        two: {
          enabled: '#076bfd',
          hover: '#076bfd',
          pressed: '#076bfd',
        },
      },
      decorative: {
        five: {
          contrast: '#e5fffd',
          enabled: '#99fff9',
          hover: 'rgba(153,255,249,0.08)',
          inverse: '#004d48',
          pressed: 'rgba(153,255,249,0.32)',
        },
        four: {
          contrast: '#e5f8ff',
          enabled: '#99e3ff',
          hover: 'rgba(153,227,255,0.08)',
          inverse: '#004a66',
          pressed: 'rgba(153,227,255,0.32)',
        },
        one: {
          contrast: '#e5f0ff',
          enabled: '#99c4ff',
          hover: 'rgba(153,196,255,0.08)',
          inverse: '#004199',
          pressed: 'rgba(153,196,255,0.32)',
        },
        three: {
          contrast: '#faeaf7',
          enabled: '#ecacdf',
          hover: 'rgba(236,172,223,0.08)',
          inverse: '#7c1d68',
          pressed: 'rgba(236,172,223,0.32)',
        },
        two: {
          contrast: '#fff4e5',
          enabled: '#ffd499',
          hover: 'rgba(255,212,153,0.08)',
          inverse: '#995900',
          pressed: 'rgba(255,212,153,0.32)',
        },
      },
      surface: {
        background: {
          disabled: 'rgba(12,15,24,0.48)',
          enabled: '#0c0f18',
          hover: '#171b26',
          pressed: '#292c32',
        },
        'background-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        backgroundInverse: {
          disabled: 'rgba(252,252,253,0.48)',
          enabled: '#fcfcfd',
          hover: '#efeff0',
          pressed: '#e2e2e4',
        },
        container: {
          gradient: {
            accent: {
              end: '#027285',
              start: '#015965',
            },
            brand: {
              end: '#b2e4f5',
              start: '#f1fbfe',
            },
            neutral: {
              end: '#292c32',
              start: '#171b26',
            },
            neutralInverse: {
              end: '#e2e2e4',
              start: '#efeff0',
            },
          },
          opaque: {
            accent: {
              disabled: 'rgba(3,179,201,0.40)',
              enabled: 'rgba(3,179,201,0.72)',
              hover: 'rgba(3,179,201,0.80)',
              pressed: 'rgba(3,179,201,0.88)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(2,114,133,0.40)',
              enabled: 'rgba(2,114,133,0.72)',
              hover: 'rgba(2,114,133,0.80)',
              pressed: 'rgba(2,114,133,0.88)',
            },
            background: {
              disabled: 'rgba(12,15,24,0.40)',
              enabled: 'rgba(12,15,24,0.72)',
              hover: 'rgba(12,15,24,0.80)',
              pressed: 'rgba(12,15,24,0.88)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(252,252,253,0.40)',
              enabled: 'rgba(252,252,253,0.72)',
              hover: 'rgba(252,252,253,0.80)',
              pressed: 'rgba(252,252,253,0.88)',
            },
            brand: {
              disabled: 'rgba(125,205,232,0.40)',
              enabled: 'rgba(125,205,232,0.72)',
              hover: 'rgba(125,205,232,0.80)',
              pressed: 'rgba(125,205,232,0.88)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(15,69,87,0.40)',
              enabled: 'rgba(15,69,87,0.72)',
              hover: 'rgba(15,69,87,0.80)',
              pressed: 'rgba(15,69,87,0.88)',
            },
            danger: {
              disabled: 'rgba(255,153,153,0.40)',
              enabled: 'rgba(255,153,153,0.72)',
              hover: 'rgba(255,153,153,0.80)',
              pressed: 'rgba(255,153,153,0.88)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(153,0,0,0.40)',
              enabled: 'rgba(153,0,0,0.72)',
              hover: 'rgba(153,0,0,0.80)',
              pressed: 'rgba(153,0,0,0.88)',
            },
            default: {
              disabled: 'rgba(41,44,50,0.40)',
              enabled: 'rgba(41,44,50,0.72)',
              hover: 'rgba(41,44,50,0.80)',
              pressed: 'rgba(41,44,50,0.88)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(212,213,216,0.40)',
              enabled: 'rgba(212,213,216,0.72)',
              hover: 'rgba(212,213,216,0.80)',
              pressed: 'rgba(212,213,216,0.88)',
            },
            subtle: {
              disabled: 'rgba(12,15,24,0.40)',
              enabled: 'rgba(12,15,24,0.72)',
              hover: 'rgba(12,15,24,0.80)',
              pressed: 'rgba(12,15,24,0.88)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(226,226,228,0.40)',
              enabled: 'rgba(226,226,228,0.72)',
              hover: 'rgba(226,226,228,0.80)',
              pressed: 'rgba(226,226,228,0.88)',
            },
            success: {
              disabled: 'rgba(153,255,170,0.40)',
              enabled: 'rgba(153,255,170,0.72)',
              hover: 'rgba(153,255,170,0.80)',
              pressed: 'rgba(153,255,170,0.88)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(0,94,15,0.40)',
              enabled: 'rgba(0,94,15,0.72)',
              hover: 'rgba(0,94,15,0.80)',
              pressed: 'rgba(0,94,15,0.88)',
            },
            warning: {
              disabled: 'rgba(59,42,2,0.40)',
              enabled: 'rgba(59,42,2,0.72)',
              hover: 'rgba(59,42,2,0.80)',
              pressed: 'rgba(59,42,2,0.88)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(102,78,0,0.40)',
              enabled: 'rgba(102,78,0,0.72)',
              hover: 'rgba(102,78,0,0.80)',
              pressed: 'rgba(102,78,0,0.88)',
            },
          },
          solid: {
            accent: {
              disabled: 'rgba(3,179,201,0.48)',
              enabled: '#03b3c9',
              hover: '#027285',
              pressed: '#015965',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: 'rgba(230,230,230,1)',
              hover: 'rgba(230,230,230,1)',
              pressed: 'rgba(230,230,230,1)',
            },
            accentInverse: {
              disabled: 'rgba(2,114,133,0.48)',
              enabled: '#027285',
              hover: '#015965',
              pressed: '#012d33',
            },
            brand: {
              disabled: 'rgba(125,205,232,0.48)',
              enabled: '#7dcde8',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            brandInverse: {
              disabled: 'rgba(15,69,87,0.48)',
              enabled: '#0f4557',
              hover: '#002d47',
              pressed: '#041116',
            },
            danger: {
              disabled: 'rgba(255,153,153,0.48)',
              enabled: '#ff9999',
              hover: '#ffb2b2',
              pressed: '#fcebeb',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            dangerInverse: {
              disabled: 'rgba(51,0,0,0.48)',
              enabled: '#990000',
              hover: '#660000',
              pressed: '#330000',
            },
            default: {
              disabled: 'rgba(23,27,38,0.48)',
              enabled: '#292c32',
              hover: '#383b42',
              pressed: '#484a51',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            defaultInverse: {
              disabled: 'rgba(212,213,216,0.48)',
              enabled: '#d4d5d8',
              hover: '#e2e2e4',
              pressed: '#efeff0',
            },
            'focus-outline': '#000000',
            'focus-outline-inverse': '#ffffff',
            focusOutline: '#041116',
            focusOutlineInverse: '#fafeff',
            subtle: {
              disabled: 'rgba(23,27,38,0.48)',
              enabled: '#0c0f18',
              hover: '#171b26',
              pressed: '#292c32',
            },
            subtleInverse: {
              disabled: 'rgba(212,213,216,0.16)',
              enabled: '#e2e2e4',
              hover: '#d4d5d8',
              pressed: '#c9cbcf',
            },
            success: {
              disabled: 'rgba(153,255,170,0.48)',
              enabled: '#99ffaa',
              hover: '#b2ffbf',
              pressed: '#ccffd4',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            successInverse: {
              disabled: 'rgba(0,69,11,0.48)',
              enabled: '#005e0f',
              hover: '#00450b',
              pressed: '#001a04',
            },
            warning: {
              disabled: 'rgba(132,97,11,0.48)',
              enabled: '#84610b',
              hover: '#6e5008',
              pressed: '#523b04',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            warningInverse: {
              disabled: 'rgba(102,78,0,0.48)',
              enabled: '#3b2a02',
              hover: '#2d2001',
              pressed: '#1e1500',
            },
          },
          translucent: {
            accent: {
              disabled: 'rgba(3,179,201,0.24)',
              enabled: 'rgba(3,179,201,0.40)',
              hover: 'rgba(3,179,201,0.48)',
              pressed: 'rgba(3,179,201,0.56)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(2,114,133,0.24)',
              enabled: 'rgba(2,114,133,0.40)',
              hover: 'rgba(2,114,133,0.48)',
              pressed: 'rgba(2,114,133,0.56)',
            },
            background: {
              disabled: 'rgba(12,15,24,0.24)',
              enabled: 'rgba(12,15,24,0.40)',
              hover: 'rgba(12,15,24,0.48)',
              pressed: 'rgba(12,15,24,0.56)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(252,252,253,0.24)',
              enabled: 'rgba(252,252,253,0.40)',
              hover: 'rgba(252,252,253,0.48)',
              pressed: 'rgba(252,252,253,0.56)',
            },
            brand: {
              disabled: 'rgba(125,205,232,0.24)',
              enabled: 'rgba(125,205,232,0.40)',
              hover: 'rgba(125,205,232,0.48)',
              pressed: 'rgba(125,205,232,0.56)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(15,69,87,0.24)',
              enabled: 'rgba(15,69,87,0.40)',
              hover: 'rgba(15,69,87,0.48)',
              pressed: 'rgba(15,69,87,0.56)',
            },
            danger: {
              disabled: 'rgba(255,153,153,0.24)',
              enabled: 'rgba(255,153,153,0.40)',
              hover: 'rgba(255,153,153,0.48)',
              pressed: 'rgba(255,153,153,0.56)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(153,0,0,0.24)',
              enabled: 'rgba(153,0,0,0.40)',
              hover: 'rgba(153,0,0,0.48)',
              pressed: 'rgba(153,0,0,0.56)',
            },
            default: {
              disabled: 'rgba(41,44,50,0.24)',
              enabled: 'rgba(41,44,50,0.40)',
              hover: 'rgba(41,44,50,0.48)',
              pressed: 'rgba(41,44,50,0.56)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(212,213,216,0.24)',
              enabled: 'rgba(212,213,216,0.40)',
              hover: 'rgba(212,213,216,0.48)',
              pressed: 'rgba(212,213,216,0.56)',
            },
            subtle: {
              disabled: 'rgba(12,15,24,0.24)',
              enabled: 'rgba(12,15,24,0.40)',
              hover: 'rgba(12,15,24,0.48)',
              pressed: 'rgba(12,15,24,0.56)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(226,226,228,0.24)',
              enabled: 'rgba(226,226,228,0.40)',
              hover: 'rgba(226,226,228,0.48)',
              pressed: 'rgba(226,226,228,0.56)',
            },
            success: {
              disabled: 'rgba(153,255,170,0.24)',
              enabled: 'rgba(153,255,170,0.40)',
              hover: 'rgba(153,255,170,0.48)',
              pressed: 'rgba(153,255,170,0.56)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(0,94,15,0.24)',
              enabled: 'rgba(0,94,15,0.40)',
              hover: 'rgba(0,94,15,0.48)',
              pressed: 'rgba(0,94,15,0.56)',
            },
            warning: {
              disabled: 'rgba(59,42,2,0.24)',
              enabled: 'rgba(59,42,2,0.40)',
              hover: 'rgba(59,42,2,0.48)',
              pressed: 'rgba(59,42,2,0.56)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(102,78,0,0.24)',
              enabled: 'rgba(102,78,0,0.40)',
              hover: 'rgba(102,78,0,0.48)',
              pressed: 'rgba(102,78,0,0.56)',
            },
          },
          transparent: {
            accent: {
              disabled: 'rgba(3,179,201,0)',
              enabled: 'rgba(3,179,201,0)',
              hover: 'rgba(3,179,201,0.08)',
              pressed: 'rgba(3,179,201,0.16)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(2,114,133,0)',
              enabled: 'rgba(2,114,133,0)',
              hover: 'rgba(2,114,133,0.08)',
              pressed: 'rgba(2,114,133,0.16)',
            },
            background: {
              disabled: 'rgba(12,15,24,0)',
              enabled: 'rgba(12,15,24,0)',
              hover: 'rgba(12,15,24,0.08)',
              pressed: 'rgba(12,15,24,0.16)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(252,252,253,0)',
              enabled: 'rgba(252,252,253,0)',
              hover: 'rgba(252,252,253,0.08)',
              pressed: 'rgba(252,252,253,0.16)',
            },
            brand: {
              disabled: 'rgba(125,205,232,0)',
              enabled: 'rgba(125,205,232,0)',
              hover: 'rgba(125,205,232,0.08)',
              pressed: 'rgba(125,205,232,0.16)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(15,69,87,0)',
              enabled: 'rgba(15,69,87,0)',
              hover: 'rgba(15,69,87,0.08)',
              pressed: 'rgba(15,69,87,0.16)',
            },
            danger: {
              disabled: 'rgba(255,153,153,0)',
              enabled: 'rgba(255,153,153,0)',
              hover: 'rgba(255,153,153,0.08)',
              pressed: 'rgba(255,153,153,0.16)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(153,0,0,0)',
              enabled: 'rgba(153,0,0,0)',
              hover: 'rgba(153,0,0,0.08)',
              pressed: 'rgba(153,0,0,0.16)',
            },
            default: {
              disabled: 'rgba(41,44,50,0)',
              enabled: 'rgba(41,44,50,0)',
              hover: 'rgba(41,44,50,0.08)',
              pressed: 'rgba(41,44,50,0.16)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(212,213,216,0)',
              enabled: 'rgba(212,213,216,0)',
              hover: 'rgba(212,213,216,0.08)',
              pressed: 'rgba(212,213,216,0.16)',
            },
            subtle: {
              disabled: 'rgba(12,15,24,0)',
              enabled: 'rgba(12,15,24,0)',
              hover: 'rgba(12,15,24,0.08)',
              pressed: 'rgba(12,15,24,0.16)',
            },
            subtleInverse: {
              disabled: 'rgba(226,226,228,0)',
              enabled: 'rgba(226,226,228,0)',
              hover: 'rgba(226,226,228,0.08)',
              pressed: 'rgba(226,226,228,0.16)',
            },
            success: {
              disabled: 'rgba(153,255,170,0)',
              enabled: 'rgba(153,255,170,0)',
              hover: 'rgba(153,255,170,0.08)',
              pressed: 'rgba(153,255,170,0.16)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(0,94,15,0)',
              enabled: 'rgba(0,94,15,0)',
              hover: 'rgba(0,94,15,0.08)',
              pressed: 'rgba(0,94,15,0.16)',
            },
            warning: {
              disabled: 'rgba(59,42,2,0)',
              enabled: 'rgba(59,42,2,0)',
              hover: 'rgba(59,42,2,0.08)',
              pressed: 'rgba(59,42,2,0.16)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(102,78,0,0)',
              enabled: 'rgba(102,78,0,0)',
              hover: 'rgba(102,78,0,0.08)',
              pressed: 'rgba(102,78,0,0.16)',
            },
          },
        },
      },
    },
    radius: {
      action: {
        100: '9999px',
        200: '4px',
        300: '9999px',
      },
      circle: '9999px',
      container: {
        100: '12px',
        200: '4px',
        300: '24px',
      },
      content: {
        100: '9999px',
        200: '12px',
        300: '4px',
        400: '8px',
        500: '12px',
      },
      input: {
        100: '12px',
        200: '4px',
      },
      navigation: {
        100: '0',
        200: '4px',
      },
      none: '0',
      overlay: {
        100: '12px',
        200: '2px',
      },
    },
    shadow: {
      levelFour: {
        blur: '24px',
        color: 'rgba(87,87,87,0.16)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      levelOne: {
        blur: '16px',
        color: 'rgba(87,87,87,0.08)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelThree: {
        blur: '20px',
        color: 'rgba(87,87,87,0.16)',
        spread: '0',
        x: '0',
        y: '8px',
      },
      levelTwo: {
        blur: '6px',
        color: 'rgba(0,94,148,0.32)',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      levelTwoHover: {
        blur: '16px',
        color: 'rgba(178,228,245,0.32)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelTwoPressed: {
        blur: '4px',
        color: 'rgba(241,251,254,0.32)',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      scrollingOverlay: {
        bottom: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '-8px',
        },
        color: 'rgba(0,0,0,0.08)',
        left: {
          blur: '16px',
          spread: '0',
          x: '8px',
          y: '0',
        },
        right: {
          blur: '16px',
          spread: '0',
          x: '-8px',
          y: '0',
        },
        stroke: '#292c32',
        top: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '8px',
        },
      },
    },
    sizing: {
      action: {
        comfortable: '40px',
        compact: '24px',
        cozy: '24px',
        expanded: '48px',
        spacious: '48px',
        vast: '64px',
      },
      breakpoint: {
        compact: '320px',
        large: '1200px',
        medium: '900px',
        small: '600px',
        xl: '1536px',
      },
      container: {
        comfortable: '320px',
        compact: '48px',
        cozy: '64px',
        expanded: '480px',
        spacious: '600px',
      },
      content: {
        comfortable: '16px',
        compact: '8px',
        cozy: '12px',
        expanded: '20px',
        spacious: '24px',
      },
      input: {
        comfortable: '64px',
        compact: '40px',
        cozy: '48px',
        expanded: '160px',
        spacious: '240px',
      },
      lineHeight: {
        bodyDefault: '24px',
        bodySmall: '21px',
        caption: '20px',
        headline: '53px',
        subheadline: '35px',
        subtile: '30px',
        title: '36px',
      },
      navigation: {
        comfortable: '40px',
        compact: '20px',
        cozy: '24px',
        expanded: '56px',
        spacious: '64px',
      },
      none: '0',
      overlay: {
        comfortable: '64px',
        compact: '24px',
        cozy: '48px',
        expanded: '240px',
        spacious: '480px',
      },
    },
    spacing: {
      action: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '24px',
        spacious: '32px',
      },
      container: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
      content: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '16px',
        spacious: '24px',
      },
      input: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '12px',
        spacious: '16px',
      },
      navigation: {
        comfortable: '16px',
        compact: '4px',
        cozy: '8px',
        expanded: '24px',
        spacious: '32px',
      },
      none: '0',
      overlay: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
    },
  },
  global: {
    motion: {
      default: {
        duration: '200ms',
        easing: 'cubic-bezier(0.38, 0.0, 1, 1)',
        transition: '200ms cubic-bezier(0.38, 0.0, 1, 1)',
      },
      instant: {
        duration: '0ms',
      },
    },
    typography: {
      default: {
        fontFamily: "'Proxima Nova', 'Nunito Sans', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
      },
    },
  },
  grid: {
    color: {
      solid: {
        default: {
          accent: {
            background: '#027285',
            border: 'rgba(212,213,216,0.08)',
          },
          brand: {
            background: '#0f4557',
            border: 'rgba(212,213,216,0.08)',
          },
          danger: {
            background: '#990000',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative1: {
            background: '#004199',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative2: {
            background: '#995900',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative3: {
            background: '#7c1d68',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative4: {
            background: '#004a66',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative5: {
            background: '#004d48',
            border: 'rgba(212,213,216,0.08)',
          },
          neutral: {
            background: '#292c32',
            border: 'rgba(212,213,216,0.08)',
          },
          success: {
            background: '#005e0f',
            border: 'rgba(212,213,216,0.08)',
          },
          warning: {
            background: '#3b2a02',
            border: 'rgba(212,213,216,0.08)',
          },
        },
        inverse: {
          accent: {
            background: '#015965',
            border: 'rgba(41,44,50,0.08)',
          },
          brand: {
            background: '#f1fbfe',
            border: 'rgba(41,44,50,0.08)',
          },
          danger: {
            background: '#fcebeb',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative1: {
            background: '#e5f0ff',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative2: {
            background: '#fff4e5',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative3: {
            background: '#faeaf7',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative4: {
            background: '#e5f8ff',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative5: {
            background: '#e5fffd',
            border: 'rgba(41,44,50,0.08)',
          },
          neutral: {
            background: '#efeff0',
            border: 'rgba(41,44,50,0.08)',
          },
          success: {
            background: '#ccffd4',
            border: 'rgba(41,44,50,0.08)',
          },
          warning: {
            background: '#fbecc8',
            border: 'rgba(41,44,50,0.08)',
          },
        },
      },
      translucent: {
        default: {
          accent: {
            background: 'rgba(2,114,133,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          brand: {
            background: 'rgba(15,69,87,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          danger: {
            background: 'rgba(153,0,0,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          neutral: {
            background: 'rgba(41,44,50,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          success: {
            background: 'rgba(0,94,15,0.56)',
            border: 'rgba(212,213,216,0.08)',
          },
          warning: {
            background: 'rgba(102,78,0,0.48)',
            border: 'rgba(212,213,216,0.08)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(3,179,201,0.40)',
            border: 'rgba(41,44,50,0.08)',
          },
          brand: {
            background: 'rgba(125,205,232,0.16)',
            border: 'rgba(41,44,50,0.08)',
          },
          danger: {
            background: 'rgba(255,153,153,0.16)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative1: {
            background: 'rgba(153,196,255,0.32)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative2: {
            background: 'rgba(255,212,153,0.32)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative3: {
            background: 'rgba(236,172,223,0.32)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative4: {
            background: 'rgba(153,227,255,0.32)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative5: {
            background: 'rgba(153,255,249,0.32)',
            border: 'rgba(41,44,50,0.08)',
          },
          neutral: {
            background: 'rgba(252,252,253,0.40)',
            border: 'rgba(41,44,50,0.08)',
          },
          success: {
            background: 'rgba(153,255,170,0.16)',
            border: 'rgba(41,44,50,0.08)',
          },
          warning: {
            background: 'rgba(244,198,90,0.48)',
            border: 'rgba(41,44,50,0.08)',
          },
        },
      },
      transparent: {
        default: {
          accent: {
            background: 'rgba(2,114,133,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          brand: {
            background: 'rgba(15,69,87,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          danger: {
            background: 'rgba(153,0,0,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          neutral: {
            background: 'rgba(41,44,50,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          success: {
            background: 'rgba(0,94,15,0.08)',
            border: 'rgba(212,213,216,0.08)',
          },
          warning: {
            background: 'rgba(102,78,0,0.16)',
            border: 'rgba(212,213,216,0.08)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(3,179,201,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          brand: {
            background: 'rgba(125,205,232,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          danger: {
            background: 'rgba(255,153,153,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative1: {
            background: 'rgba(153,196,255,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative2: {
            background: 'rgba(255,212,153,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative3: {
            background: 'rgba(236,172,223,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative4: {
            background: 'rgba(153,227,255,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          decorative5: {
            background: 'rgba(153,255,249,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          neutral: {
            background: 'rgba(212,213,216,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          success: {
            background: 'rgba(153,255,170,0.08)',
            border: 'rgba(41,44,50,0.08)',
          },
          warning: {
            background: 'rgba(59,42,2,0.16)',
            border: 'rgba(41,44,50,0.08)',
          },
        },
      },
    },
    effects: {
      default: {
        blur: {
          background: '48px',
        },
      },
    },
    layout: {
      default: {
        count: '12px',
        gutter: '16px',
        margin: '0',
      },
    },
    radius: {
      default: {
        default: '8px',
      },
      round: {
        default: '24px',
      },
      sharp: {
        default: '12px',
      },
    },
    sizing: {
      default: {
        border: '1px',
      },
    },
    spacing: {
      compact: {
        padding: '8px',
      },
      default: {
        padding: '16px',
      },
      spacious: {
        padding: '24px',
      },
    },
  },
  gridlines: {
    default: {
      color: {
        content: {
          enabled: '#4d4d4d',
        },
        grids: {
          enabled: '#808080',
        },
      },
      padding: {
        bottom: '8px',
        gap: '8px',
        left: '8px',
        right: '8px',
        top: '4px',
      },
    },
  },
  hero: {
    accent: {
      color: {
        content: {
          enabled: '#292c32',
        },
        surface: {
          enabled: '#03b3c9',
          gradient: {
            stop1: '#015965',
            stop2: '#027285',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    brand: {
      color: {
        content: {
          enabled: '#292c32',
        },
        surface: {
          enabled: '#7dcde8',
          gradient: {
            stop1: '#f1fbfe',
            stop2: '#b2e4f5',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    classic: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#99c4ff',
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '16px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    inverse: {
      color: {
        content: {
          enabled: '#292c32',
        },
        surface: {
          enabled: '#000000',
          gradient: {
            stop1: '#efeff0',
            stop2: '#e2e2e4',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    neutral: {
      color: {
        content: {
          enabled: '#e2e2e4',
        },
        surface: {
          enabled: '#0c0f18',
          gradient: {
            stop1: '#171b26',
            stop2: '#292c32',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
  },
  icon: {
    IDS: {
      color: {
        internalDesignBackground: '#d4d5d8',
      },
      sizing: {
        lg: {
          height: '40px',
          width: '40px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '20px',
          width: '20px',
        },
        xs: {
          height: '16px',
          width: '16px',
        },
      },
    },
    SLDS: {
      color: {
        internalDesignBackground: '#d4d5d8',
      },
      sizing: {
        lg: {
          height: '26px',
          width: '26px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '14px',
          width: '14px',
        },
        xs: {
          height: '10px',
          width: '10px',
        },
      },
    },
  },
  iconButton: {
    default: {
      color: {
        background: {
          disabled: 'rgba(125,205,232,0)',
          enabled: 'rgba(125,205,232,0)',
          filled: '#292c32',
          focus: 'rgba(125,205,232,0.08)',
          hover: 'rgba(125,205,232,0.08)',
          pressed: 'rgba(125,205,232,0.16)',
          selected: '#7dcde8',
        },
        border: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          focus: '#61636b',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
        icon: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#b2e4f5',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
          selected: '#ffffff',
        },
        outline: '#fafeff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,153,153,0)',
          enabled: 'rgba(255,153,153,0)',
          filled: '#292c32',
          focus: 'rgba(255,153,153,0.08)',
          hover: 'rgba(255,153,153,0.08)',
          pressed: 'rgba(255,153,153,0.16)',
          selected: '#ff9999',
        },
        border: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          focus: '#61636b',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        icon: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#ffb2b2',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
          selected: '#ffffff',
        },
        outline: '#fafeff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColor: {
      color: {
        background: {
          disabled: 'rgba(41,44,50,0)',
          enabled: 'rgba(41,44,50,0)',
          filled: '#d4d5d8',
          focus: 'rgba(41,44,50,0.08)',
          hover: 'rgba(41,44,50,0.08)',
          pressed: 'rgba(41,44,50,0.16)',
        },
        border: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        icon: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#171b26',
          hover: '#171b26',
          pressed: '#0c0f18',
        },
        outline: '#ffffff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColorInverse: {
      color: {
        background: {
          disabled: 'rgba(212,213,216,0)',
          enabled: 'rgba(212,213,216,0)',
          filled: '#d4d5d8',
          focus: 'rgba(212,213,216,0.08)',
          hover: 'rgba(212,213,216,0.08)',
          pressed: 'rgba(212,213,216,0.16)',
        },
        border: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
        icon: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#efeff0',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#e2e2e4',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    toggle: {
      color: {
        background: {
          disabled: 'rgba(125,205,232,0)',
          enabled: 'rgba(125,205,232,0)',
          filled: '#292c32',
          focus: 'rgba(125,205,232,0.08)',
          hover: 'rgba(125,205,232,0.08)',
          pressed: 'rgba(125,205,232,0.16)',
          selected: '#000000',
        },
        border: {
          disabled: '#484a51',
          enabled: '#292c32',
          focus: '#61636b',
          hover: '#484a51',
          pressed: '#383b42',
        },
        icon: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#e2e2e4',
          hover: '#e2e2e4',
          pressed: '#efeff0',
          selected: '#ffffff',
        },
        outline: '#fafeff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  label: {
    default: {
      color: {
        asterisk: '#ff9999',
        optional: '#d4d5d8',
        text: '#e2e2e4',
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  list: {
    default: {
      color: {
        background: {
          inset: '#0c0f18',
        },
        border: '#292c32',
        scrollbar: 'rgba(212,213,216,0.16)',
      },
      radius: '12px',
      spacing: {
        padding: {
          compact: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '8px',
              top: '8px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          default: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  listItem: {
    default: {
      color: {
        background: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          focus: '#484a51',
          hover: '#383b42',
          pressed: '#171b26',
        },
        border: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#484a51',
          hover: '#383b42',
          pressed: '#484a51',
        },
        icon: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
        leadingIcon: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#f1fbfe',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
        text: {
          label: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#f1fbfe',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          sub: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#f1fbfe',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        trailingIcon: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          focus: '#f1fbfe',
          hover: '#b2e4f5',
          pressed: '#f1fbfe',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          focus: '#484a51',
          hover: '#383b42',
          pressed: '#171b26',
        },
        border: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#484a51',
          hover: '#383b42',
          pressed: '#484a51',
        },
        icon: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        leadingIcon: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ffcccc',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        text: {
          label: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ffcccc',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
          sub: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ffcccc',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
        },
        trailingIcon: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ffcccc',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  menu: {
    default: {
      color: {
        background: {
          list: '#292c32',
        },
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '8px',
          left: '0',
          list: {
            bottom: '8px',
            gap: '0',
            left: '0',
            right: '0',
            top: '8px',
          },
          right: '0',
          top: '0',
        },
      },
    },
  },
  modal: {
    default: {
      color: {
        body: {
          text: '#e2e2e4',
        },
        border: '#292c32',
        colorBar: '#7dcde8',
        container: '#292c32',
        header: {
          heading: '#e2e2e4',
          subheading: '#d4d5d8',
        },
        scrim: 'rgba(212,213,216,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      color: {
        body: {
          text: '#e2e2e4',
        },
        border: '#292c32',
        colorBar: '#ff9999',
        container: '#292c32',
        header: {
          heading: '#e2e2e4',
          subheading: '#d4d5d8',
        },
        scrim: 'rgba(212,213,216,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    success: {
      color: {
        body: {
          text: '#e2e2e4',
        },
        border: '#292c32',
        colorBar: '#99ffaa',
        container: '#292c32',
        header: {
          heading: '#e2e2e4',
          subheading: '#d4d5d8',
        },
        scrim: 'rgba(212,213,216,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    warning: {
      color: {
        body: {
          text: '#e2e2e4',
        },
        border: '#292c32',
        colorBar: '#6e5008',
        container: '#292c32',
        header: {
          heading: '#e2e2e4',
          subheading: '#d4d5d8',
        },
        scrim: 'rgba(212,213,216,0.48)',
      },
      radius: {
        container: '12px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  navItem: {
    inverse: {
      color: {
        background: {
          control: {
            disabled: 'rgba(252,252,253,0.24)',
            enabled: 'rgba(252,252,253,0.40)',
            focus: 'rgba(252,252,253,0.40)',
            hover: 'rgba(125,205,232,0.40)',
            pressed: 'rgba(125,205,232,0.56)',
          },
          default: {
            disabled: 'rgba(252,252,253,0)',
            enabled: 'rgba(252,252,253,0)',
            focus: 'rgba(252,252,253,0)',
            hover: 'rgba(252,252,253,0.16)',
            pressed: 'rgba(252,252,253,0.40)',
          },
          insetGroup: 'rgba(12,15,24,0.08)',
          selected: {
            enabled: 'rgba(41,44,50,0.08)',
            focus: 'rgba(41,44,50,0.08)',
            hover: 'rgba(41,44,50,0.16)',
            pressed: 'rgba(41,44,50,0.16)',
          },
        },
        border: {
          default: 'rgba(226,226,228,0.16)',
          focus: '#041116',
          selected: 'rgba(252,252,253,0.40)',
        },
        content: {
          control: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#0f4557',
            pressed: '#002d47',
          },
          default: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#002d47',
            pressed: '#041116',
          },
          selected: {
            enabled: '#041116',
            focus: '#041116',
            hover: '#08232c',
            pressed: '#0f4557',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '8px',
      },
    },
    neutral: {
      color: {
        background: {
          control: {
            disabled: 'rgba(41,44,50,0.40)',
            enabled: 'rgba(41,44,50,0.72)',
            focus: 'rgba(41,44,50,0.72)',
            hover: 'rgba(15,69,87,0.72)',
            pressed: 'rgba(15,69,87,0.88)',
          },
          default: {
            disabled: 'rgba(12,15,24,0)',
            enabled: 'rgba(12,15,24,0)',
            focus: 'rgba(12,15,24,0)',
            hover: 'rgba(12,15,24,0.16)',
            pressed: 'rgba(12,15,24,0.40)',
          },
          insetGroup: 'rgba(226,226,228,0.08)',
          selected: {
            enabled: 'rgba(226,226,228,0.08)',
            focus: 'rgba(226,226,228,0.08)',
            hover: 'rgba(226,226,228,0.16)',
            pressed: 'rgba(226,226,228,0.16)',
          },
        },
        border: {
          default: 'rgba(226,226,228,0.08)',
          focus: '#fafeff',
          selected: 'rgba(12,15,24,0.40)',
        },
        content: {
          control: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          default: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
          selected: {
            enabled: '#b2e4f5',
            focus: '#b2e4f5',
            hover: '#f1fbfe',
            pressed: '#f1fbfe',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '8px',
      },
    },
  },
  navbar: {
    accent: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
            selected: '#0c0f18',
          },
          text: {
            enabled: '#292c32',
          },
        },
        notificationBell: '#d4d5d8',
        outline: {
          focus: '#027285',
        },
        surface: {
          background: {
            enabled: '#027285',
            gradient: {
              stop1: '#015965',
              stop2: '#027285',
            },
            overlay: 'rgba(3,179,201,0.16)',
          },
          item: {
            disabled: 'rgba(3,179,201,0)',
            enabled: 'rgba(3,179,201,0)',
            focus: 'rgba(3,179,201,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#7dcde8',
          four: '#03b3c9',
          one: '#292c32',
          three: '#ecacdf',
          two: '#efeff0',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    brand: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
            selected: '#0c0f18',
          },
          text: {
            enabled: '#292c32',
          },
        },
        notificationBell: '#d4d5d8',
        outline: {
          focus: '#0f4557',
        },
        surface: {
          background: {
            enabled: '#b2e4f5',
            gradient: {
              stop1: '#f1fbfe',
              stop2: '#b2e4f5',
            },
            overlay: 'rgba(125,205,232,0.16)',
          },
          item: {
            disabled: 'rgba(125,205,232,0)',
            enabled: 'rgba(125,205,232,0)',
            focus: 'rgba(125,205,232,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#03b3c9',
          four: '#7dcde8',
          one: '#292c32',
          three: '#99fff9',
          two: '#fcfcfd',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    classic: {
      color: {
        border: {
          sidebarItem: 'rgba(37,0,86,0.12)',
        },
        content: {
          item: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
            selected: '#0c0f18',
          },
          text: {
            enabled: '#292c32',
          },
        },
        notificationBell: '#d4d5d8',
        outline: {
          focus: '#0f4557',
        },
        surface: {
          background: {
            enabled: '#99c4ff',
            gradient: {
              stop1: '#99c4ff',
              stop2: '#0076ae',
            },
            overlay: 'rgba(153,196,255,0.08)',
          },
          item: {
            disabled: 'rgba(12,15,24,0)',
            enabled: 'rgba(12,15,24,0)',
            focus: 'rgba(12,15,24,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#292c32',
          four: '#292c32',
          one: '#292c32',
          three: '#292c32',
          two: '#efeff0',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '29px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    inverse: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#383b42',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
            selected: '#0c0f18',
          },
          text: {
            enabled: '#292c32',
          },
        },
        notificationBell: '#d4d5d8',
        outline: {
          focus: '#0f4557',
        },
        surface: {
          background: {
            enabled: '#e2e2e4',
            gradient: {
              stop1: '#efeff0',
              stop2: '#e2e2e4',
            },
            overlay: 'rgba(212,213,216,0.16)',
          },
          item: {
            disabled: 'rgba(12,15,24,0)',
            enabled: 'rgba(12,15,24,0)',
            focus: 'rgba(12,15,24,0)',
            hover: 'rgba(230,230,230,0.08)',
            pressed: 'rgba(230,230,230,0.12)',
            selected: 'rgba(230,230,230,0.18)',
          },
        },
        wave: {
          five: '#027285',
          four: '#b2e4f5',
          one: '#7dcde8',
          three: 'rgba(153,255,249,0.32)',
          two: '#fcfcfd',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    neutral: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
            selected: '#fcfcfd',
          },
          text: {
            enabled: '#e2e2e4',
          },
        },
        notificationBell: '#d4d5d8',
        outline: {
          focus: '#b2e4f5',
        },
        surface: {
          background: {
            enabled: '#0c0f18',
            gradient: {
              stop1: '#171b26',
              stop2: '#292c32',
            },
            overlay: 'rgba(12,15,24,0.16)',
          },
          item: {
            disabled: 'rgba(212,213,216,0)',
            enabled: 'rgba(212,213,216,0)',
            focus: 'rgba(212,213,216,0)',
            hover: 'rgba(77,77,77,0.08)',
            pressed: 'rgba(77,77,77,0.12)',
            selected: 'rgba(77,77,77,0.18)',
          },
        },
        wave: {
          five: '#027285',
          four: '#0f4557',
          one: '#7dcde8',
          three: 'rgba(236,172,223,0.32)',
          two: 'rgba(212,213,216,0.16)',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  pagination: {
    default: {
      color: {
        barBackground: {
          enabled: '#0c0f18',
        },
        barBorder: {
          enabled: '#292c32',
        },
        label: {
          enabled: '#d4d5d8',
        },
        outline: '#fafeff',
      },
      padding: {
        multiPage: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        pagination: {
          bottom: '10px',
          gap: '0',
          left: '16px',
          right: '16px',
          top: '10px',
        },
        select: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        singlePage: {
          bottom: '0',
          gap: '0',
          left: '4px',
          right: '4px',
          top: '0',
        },
        tabs: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        textField: {
          left: '4px',
        },
      },
      radius: {
        radius: '0',
      },
    },
  },
  passwordInput: {
    default: {
      spacing: {
        bottom: '0',
        gap: '4px',
        left: '16px',
        right: '0',
        top: '0',
      },
    },
  },
  progressIndicator: {
    default: {
      circular: {
        color: {
          indicator: {
            live: '#7dcde8',
            track: '#383b42',
          },
          solid: {
            background: '#efeff0',
            indicator: {
              live: '#041116',
              track: '#d4d5d8',
            },
            text: '#292c32',
          },
          transparent: {
            background: 'rgba(41,44,50,0)',
            indicator: {
              live: '#7dcde8',
              track: '#171b26',
            },
            text: '#e2e2e4',
          },
        },
        padding: {
          container: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          content: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
          indicator: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        radius: {
          container: '12px',
          live: '9999px',
          track: '9999px',
        },
      },
      ids: {
        color: {
          indicator: {
            neutral: '#d4d5d8',
            oval1: '#99e3ff',
            oval2: '#99fff9',
            oval3: '#ecacdf',
            oval4: '#ffd499',
          },
          solid: {
            background: '#efeff0',
            text: '#292c32',
          },
          transparent: {
            background: 'rgba(41,44,50,0)',
            text: '#e2e2e4',
          },
        },
        padding: {
          container: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
        },
        radius: {
          container: '12px',
        },
      },
      wrapper: {
        color: {
          scrim: {
            blurred: 'rgba(41,44,50,0.72)',
            solid: '#292c32',
          },
        },
      },
    },
  },
  progressIndicatorDesignOnly: {
    default: {
      container: 'transparent',
      mode: 'default',
    },
  },
  radio: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(125,205,232,0.48)',
              enabled: '#7dcde8',
              focus: '#7dcde8',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
            unselected: {
              disabled: 'rgba(125,205,232,0)',
              enabled: 'rgba(125,205,232,0)',
              focus: 'rgba(125,205,232,0)',
              hover: 'rgba(125,205,232,0.08)',
              pressed: 'rgba(125,205,232,0.16)',
            },
          },
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        help: {
          enabled: '#d4d5d8',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#fafeff',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '12px',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(255,153,153,0.48)',
              enabled: '#ff9999',
              focus: '#ff9999',
              hover: '#ffb2b2',
              pressed: '#fcebeb',
            },
            unselected: {
              disabled: 'rgba(255,153,153,0)',
              enabled: 'rgba(255,153,153,0)',
              focus: 'rgba(255,153,153,0)',
              hover: 'rgba(255,153,153,0.08)',
              pressed: 'rgba(255,153,153,0.16)',
            },
          },
          border: {
            disabled: 'rgba(255,153,153,0.48)',
            enabled: '#ff9999',
            focus: '#ff9999',
            hover: '#ffb2b2',
            pressed: '#ffcccc',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        help: {
          enabled: '#ff9999',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#fafeff',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '12px',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '24px',
            width: '24px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  responsiveNavbar: {
    lg: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1535px',
        min: '1200px',
      },
    },
    md: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1199px',
        min: '900px',
      },
    },
    sm: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '899px',
        min: '600px',
      },
    },
    xl: {
      spacing: {
        sm: '8px',
      },
      width: {
        max: '2000px',
        min: '1536px',
      },
    },
    xs: {
      spacing: {
        sm: '2px',
      },
      width: {
        max: '599px',
        min: '320px',
      },
    },
  },
  segmentedControl: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(15,69,87,0.48)',
            enabled: '#041116',
            hover: '#002d47',
            pressed: '#0f4557',
          },
          unselected: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            hover: '#0f4557',
            pressed: '#002d47',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            enabledHover: '#484a51',
            enabledPressed: '#383b42',
          },
          unselected: '#61636b',
        },
        content: {
          selected: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#f1fbfe',
            hover: '#f1fbfe',
            pressed: '#7dcde8',
          },
          unselected: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#fafeff',
          shadow: '#041116',
        },
      },
      radius: {
        container: '0',
        group: '9999px',
      },
      sizing: {
        small: {
          minHeight: '40px',
          minWidth: '40px',
        },
        standard: {
          minHeight: '48px',
          minWidth: '48px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '24px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '24px',
        },
      },
    },
    inverse: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            hover: '#383b42',
            pressed: '#484a51',
          },
          unselected: {
            disabled: 'rgba(212,213,216,0)',
            enabled: 'rgba(212,213,216,0)',
            hover: 'rgba(212,213,216,0.40)',
            pressed: 'rgba(212,213,216,0.56)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            enabledHover: '#383b42',
            enabledPressed: '#484a51',
          },
          unselected: '#292c32',
        },
        content: {
          selected: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          unselected: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#fafeff',
          shadow: '#041116',
        },
      },
      radius: {
        container: '0',
        group: '9999px',
      },
      sizing: {
        small: {
          minHeight: '40px',
          minWidth: '40px',
        },
        standard: {
          minHeight: '48px',
          minWidth: '48px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '24px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '24px',
        },
      },
    },
    neutral: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            hover: '#e2e2e4',
            pressed: '#efeff0',
          },
          unselected: {
            disabled: 'rgba(41,44,50,0)',
            enabled: 'rgba(41,44,50,0)',
            hover: 'rgba(41,44,50,0.40)',
            pressed: 'rgba(41,44,50,0.56)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            enabledHover: '#484a51',
            enabledPressed: '#383b42',
          },
          unselected: '#d4d5d8',
        },
        content: {
          selected: {
            disabled: 'rgba(15,69,87,0.48)',
            enabled: '#0f4557',
            hover: '#08232c',
            pressed: '#041116',
          },
          unselected: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#fafeff',
          shadow: '#041116',
        },
      },
      radius: {
        container: '0',
        group: '9999px',
      },
      sizing: {
        small: {
          minHeight: '40px',
          minWidth: '40px',
        },
        standard: {
          minHeight: '48px',
          minWidth: '48px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '24px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '24px',
        },
      },
    },
  },
  select: {
    default: {
      color: {
        background: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#383b42',
          pressed: '#292c32',
        },
        border: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          focus: '#61636b',
          hover: '#484a51',
          pressed: '#7dcde8',
        },
        help: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
        input: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
      },
      outline: '#fafeff',
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#383b42',
          pressed: '#292c32',
        },
        border: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        help: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        input: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
      },
      outline: '#fafeff',
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  slider: {
    default: {
      color: {
        bar: {
          disabled: 'rgba(125,205,232,0.48)',
          enabled: '#7dcde8',
        },
        handle: {
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
            focus: '#61636b',
            hover: '#7dcde8',
            pressed: '#7dcde8',
          },
          fill: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        helpAndValueText: {
          default: '#e2e2e4',
          disabled: 'rgba(226,226,228,0.48)',
        },
        helpText: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
        },
        tickMark: {
          bar: {
            default: '#292c32',
            disabled: 'rgba(41,44,50,0.48)',
          },
          track: {
            default: '#7dcde8',
            disabled: 'rgba(125,205,232,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
          },
          disabled: 'rgba(56,59,66,0.48)',
          enabled: '#383b42',
          fill: {
            disabled: 'rgba(12,15,24,0.48)',
            enabled: '#0c0f18',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(5,87,213,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(5,87,213,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '24px',
            width: '24px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '40px',
            width: '40px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
    error: {
      color: {
        bar: {
          disabled: 'rgba(56,59,66,0.48)',
          enabled: '#ff9999',
        },
        handle: {
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#ff9999',
            focus: '#61636b',
            hover: '#ff9999',
            pressed: '#ff9999',
          },
          fill: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        helpAndValueText: {
          default: '#ff9999',
          disabled: 'rgba(255,153,153,0.48)',
        },
        helpText: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
        },
        tickMark: {
          bar: {
            default: '#292c32',
            disabled: 'rgba(41,44,50,0.48)',
          },
          track: {
            default: '#7dcde8',
            disabled: 'rgba(125,205,232,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#ff9999',
          },
          disabled: 'rgba(56,59,66,0.48)',
          enabled: '#383b42',
          fill: {
            disabled: 'rgba(12,15,24,0.48)',
            enabled: '#0c0f18',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(189,1,0,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(189,1,0,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '24px',
            width: '24px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '40px',
            width: '40px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
  },
  splitButton: {
    default: {
      color: {
        border: {
          primary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
          secondary: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
          },
          tertiary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
        },
      },
      padding: {
        gap: '0',
      },
      radius: {
        button1: '0',
        button2: '0',
        button3: '0',
        button4: '0',
        buttonGroup: '9999px',
      },
    },
  },
  stepper: {
    default: {
      color: {
        boxBorder: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#383b42',
          pressed: '#484a51',
        },
        completed: {
          box: {
            disabled: 'rgba(12,15,24,0.48)',
            enabled: '#0c0f18',
            focus: '#0c0f18',
            hover: '#171b26',
            pressed: '#292c32',
          },
          divider: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
          },
          icon: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          path: {
            enabled: '#7dcde8',
          },
          text: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
        focusBorder: '#fafeff',
        inProgress: {
          box: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#292c32',
          },
          icon: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          text: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
        incomplete: {
          box: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#383b42',
            pressed: '#484a51',
          },
          divider: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
          },
          icon: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            hover: '#e2e2e4',
            pressed: '#efeff0',
          },
          path: {
            enabled: '#484a51',
          },
          text: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
      },
      radius: {
        container: '12px',
        path: '9999px',
        pathStart: '9999px',
      },
      sizing: {
        box: {
          'max-height': '480px',
          'max-width': '480px',
          'min-height': '64px',
          'min-width': '64px',
        },
        horizontal: {
          max: {
            width: '160px',
          },
        },
        text: {
          max: {
            width: '480px',
          },
          min: {
            height: '48px',
            width: '48px',
          },
        },
      },
      spacing: {
        box: {
          bottom: '8px',
          gap: '8px',
          left: '12px',
          right: '16px',
          text: {
            bottom: '4px',
            top: '4px',
          },
          top: '8px',
        },
        boxGroup: {
          gap: '8px',
        },
        horizontal: {
          gap: '4px',
          gapNegative: '-8px',
          text: {
            side: '16px',
          },
        },
        vertical: {
          gap: '8px',
          path: {
            gap: '2px',
          },
          text: {
            bottom: '8px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  switch: {
    default: {
      color: {
        helpText: '#e2e2e4',
        off: {
          background: {
            disabled: 'rgba(212,213,216,0.16)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#d4d5d8',
            pressed: '#c9cbcf',
          },
          handle: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        on: {
          background: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
          handle: {
            disabled: '#292c32',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
        outline: '#fafeff',
      },
      radius: {
        container: '9999px',
        handle: '9999px',
      },
      sizing: {
        small: {
          switch: {
            height: '24px',
            width: '48px',
          },
        },
        standard: {
          switch: {
            height: '40px',
            width: '64px',
          },
        },
      },
      spacing: {
        small: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
        standard: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
      },
    },
  },
  table: {
    default: {
      background: '#292c32',
      border: {
        color: '#292c32',
        colorFrozen: '#383b42',
        radius: '12px',
        stroke: '1px',
      },
      shadow: {
        blur: '16px',
        color: 'rgba(87,87,87,0.08)',
        default: {
          blur: '16px',
          color: 'rgba(87,87,87,0.08)',
          spread: '0',
          x: '0',
          y: '4px',
        },
        frozen: {
          blur: '20px',
          color: 'rgba(87,87,87,0.16)',
          spread: '0',
          x: '8px',
          y: '0',
        },
        spread: '0',
        x: '0',
        y: '4px',
      },
      shadowFrozen: {
        blur: '20px',
        color: 'rgba(87,87,87,0.16)',
        spread: '0',
        x: '8px',
        y: '0',
      },
      tableCell: {
        border: {
          control: {
            color: {
              editable: '#484a51',
              enabled: '#292c32',
              hover: '#383b42',
            },
            stroke: '1px',
          },
          head: {
            color: {
              enabled: '#292c32',
              hover: '#383b42',
              selected: '#292c32',
            },
            stroke: '1px',
          },
          text: {
            color: {
              editable: '#484a51',
              enabled: '#292c32',
              hover: '#383b42',
              selected: '#7dcde8',
            },
            stroke: '1px',
          },
          textSelected: {
            stroke: '1px',
          },
        },
        color: {
          control: {
            background: {
              editable: '#0c0f18',
              enabled: '#292c32',
              hover: '#0f4557',
            },
            label: {
              editable: '#fcfcfd',
              enabled: '#e2e2e4',
              hover: '#efeff0',
            },
          },
          head: {
            background: {
              enabled: '#0c0f18',
              hover: '#171b26',
              selected: '#0c0f18',
            },
            icon: {
              enabled: '#e2e2e4',
              hover: '#7dcde8',
            },
            label: {
              enabled: '#e2e2e4',
              hover: '#efeff0',
              selected: '#fcfcfd',
            },
          },
          text: {
            background: {
              editable: '#0c0f18',
              enabled: '#292c32',
              hover: '#0f4557',
              selected: '#002d47',
            },
            label: {
              editable: '#fcfcfd',
              enabled: '#e2e2e4',
              hover: '#efeff0',
              selected: '#b2e4f5',
            },
          },
        },
        minHeight: '48px',
        padding: {
          control: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '4px',
          },
          head: {
            firstChild: '12px',
            gap: '4px',
            horizontal: '4px',
            lastChild: '12px',
            vertical: '12px',
          },
          text: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '12px',
          },
        },
      },
      tableRowExpanded: {
        color: {
          background: '#0c0f18',
          border: '#292c32',
          label: '#e2e2e4',
        },
        padding: {
          editTop: '16px',
          gap: '32px',
          horizontal: '24px',
          vertical: '8px',
        },
      },
      tableToolbar: {
        color: {
          background: '#292c32',
          label: '#e2e2e4',
        },
        padding: {
          gap: '8px',
          horizontal: '16px',
          vertical: '16px',
        },
      },
    },
  },
  tabs: {
    default: {
      color: {
        background: {
          box: {
            disabled: 'rgba(12,15,24,0.48)',
            enabled: '#0c0f18',
            focus: '#0c0f18',
            hover: '#171b26',
            pressed: '#292c32',
          },
          disabled: 'rgba(41,44,50,0)',
          enabled: 'rgba(41,44,50,0)',
          focus: 'rgba(41,44,50,0)',
          hover: '#171b26',
          pressed: '#292c32',
        },
        border: {
          disabled: 'rgba(41,44,50,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#383b42',
          nested: 'rgba(255,255,255,0)',
          pressed: '#484a51',
          selected: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#fafeff',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        icon: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
          selected: {
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
        },
        label: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
          selected: {
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
            sublabel: '#d4d5d8',
          },
        },
        outline: {
          focus: '#fafeff',
        },
      },
      radius: {
        horizontal: {
          bl: '0',
          bottomLeft: '0',
          bottomRight: '0',
          br: '0',
          tl: '4px',
          topLeft: '4px',
          topRight: '4px',
          tr: '4px',
        },
        vertical: {
          bl: '4px',
          bottomLeft: '4px',
          bottomRight: '0',
          br: '0',
          tl: '4px',
          topLeft: '4px',
          topRight: '0',
          tr: '0',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        min: {
          height: '40px',
          width: '40px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        tabList: {
          box: {
            bottom: '0',
            gap: '4px',
            left: '0',
            right: '0',
            top: '0',
          },
          line: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
      },
    },
  },
  tag: {
    default: {
      color: {
        background: {
          default: {
            accent: '#03b3c9',
            brand: '#7dcde8',
            danger: '#ff9999',
            decorative1: '#99c4ff',
            decorative2: '#ffd499',
            decorative3: '#ecacdf',
            decorative4: '#99e3ff',
            decorative5: '#99fff9',
            neutral: '#d4d5d8',
            success: '#99ffaa',
            warning: '#84610b',
          },
          inverse: {
            accent: '#027285',
            brand: '#0f4557',
            danger: '#990000',
            decorative1: '#004199',
            decorative2: '#995900',
            decorative3: '#7c1d68',
            decorative4: '#004a66',
            decorative5: '#004d48',
            neutral: '#0c0f18',
            success: '#005e0f',
            warning: '#3b2a02',
          },
        },
        content: {
          accent: '#03b3c9',
          brand: '#7dcde8',
          danger: '#ff9999',
          decorative1: '#e5f0ff',
          decorative2: '#fff4e5',
          decorative3: '#faeaf7',
          decorative4: '#e5f8ff',
          decorative5: '#e5fffd',
          neutral: '#292c32',
          neutralInverse: '#e2e2e4',
          success: '#99ffaa',
          warning: '#f7d991',
        },
        icon: '#ffffff',
        label: '#ffffff',
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        min: {
          height: '20px',
          width: '20px',
        },
        padding: {
          bottom: '1px',
          gap: '4px',
          icon: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          left: '8px',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  textArea: {
    default: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
    error: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
  },
  textField: {
    default: {
      color: {
        background: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#292c32',
          pressed: '#292c32',
        },
        border: {
          disabled: 'rgba(97,99,107,0.48)',
          enabled: '#61636b',
          focus: '#7dcde8',
          hover: '#7dcde8',
          pressed: '#b2e4f5',
        },
        help: {
          disabled: 'rgba(212,213,216,0.48)',
          enabled: '#d4d5d8',
          focus: '#d4d5d8',
          hover: '#e2e2e4',
          pressed: '#efeff0',
        },
        input: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#fafeff',
        placeholder: '#484a51',
      },
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(23,27,38,0.48)',
          enabled: '#292c32',
          focus: '#292c32',
          hover: '#292c32',
          pressed: '#292c32',
        },
        border: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ffcccc',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        help: {
          disabled: 'rgba(255,153,153,0.48)',
          enabled: '#ff9999',
          focus: '#ff9999',
          hover: '#ffb2b2',
          pressed: '#ffcccc',
        },
        input: {
          disabled: 'rgba(226,226,228,0.48)',
          enabled: '#e2e2e4',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        label: {
          disabled: 'rgba(226,226,228,0.48)',
          focus: '#e2e2e4',
          hover: '#efeff0',
          pressed: '#fcfcfd',
        },
        outline: '#fafeff',
        placeholder: '#484a51',
      },
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '40px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '48px',
            width: '48px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
  },
  textLink: {
    default: {
      color: {
        disabled: {
          icon: 'rgba(125,205,232,0.48)',
          text: 'rgba(125,205,232,0.48)',
        },
        enabled: {
          icon: '#7dcde8',
          text: '#7dcde8',
        },
        focus: {
          icon: '#7dcde8',
          text: '#7dcde8',
        },
        hover: {
          icon: '#b2e4f5',
          text: '#b2e4f5',
        },
        outline: '#fafeff',
        pressed: {
          icon: '#f1fbfe',
          text: '#f1fbfe',
        },
      },
      radius: {
        small: '12px',
        standard: '12px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        padding: {
          small: {
            gap: '4px',
          },
          standard: {
            gap: '4px',
          },
        },
      },
    },
  },
  timePicker: {
    default: {
      color: {
        background: {
          now: '#0c0f18',
        },
        border: {
          root: {
            disabled: 'rgba(97,99,107,0.48)',
            enabled: '#61636b',
          },
        },
        text: {
          readOnly: '#d4d5d8',
        },
      },
    },
  },
  toast: {
    default: {
      color: {
        background: '#d4d5d8',
        border: 'rgba(255,255,255,0)',
        icon: '#292c32',
        iconButton: {
          background: {
            disabled: 'rgba(41,44,50,0)',
            enabled: 'rgba(41,44,50,0)',
            focused: 'rgba(41,44,50,0)',
            hover: 'rgba(41,44,50,0.08)',
            pressed: 'rgba(41,44,50,0.16)',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focused: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          outline: '#292c32',
        },
        text: '#292c32',
        textLink: {
          disabled: {
            icon: '#0f4557',
            text: '#0f4557',
          },
          enabled: {
            icon: '#0f4557',
            text: '#0f4557',
          },
          focused: {
            icon: '#0f4557',
            text: '#0f4557',
          },
          hover: {
            icon: '#08232c',
            text: '#08232c',
          },
          outline: '#0f4557',
          pressed: {
            icon: '#041116',
            text: '#041116',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    error: {
      color: {
        background: '#ff9999',
        border: 'rgba(255,255,255,0)',
        icon: '#292c32',
        iconButton: {
          background: {
            disabled: 'rgba(41,44,50,0)',
            enabled: 'rgba(41,44,50,0)',
            focused: 'rgba(41,44,50,0)',
            hover: 'rgba(41,44,50,0.08)',
            pressed: 'rgba(41,44,50,0.16)',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focused: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          outline: '#292c32',
        },
        text: '#292c32',
        textLink: {
          disabled: {
            icon: '#292c32',
            text: '#292c32',
          },
          enabled: {
            icon: '#292c32',
            text: '#292c32',
          },
          focused: {
            icon: '#292c32',
            text: '#292c32',
          },
          hover: {
            icon: '#171b26',
            text: '#171b26',
          },
          outline: '#292c32',
          pressed: {
            icon: '#0c0f18',
            text: '#0c0f18',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    success: {
      color: {
        background: '#99ffaa',
        border: 'rgba(255,255,255,0)',
        icon: '#292c32',
        iconButton: {
          background: {
            disabled: 'rgba(41,44,50,0)',
            enabled: 'rgba(41,44,50,0)',
            focused: 'rgba(41,44,50,0)',
            hover: 'rgba(41,44,50,0.08)',
            pressed: 'rgba(41,44,50,0.16)',
          },
          icon: {
            disabled: '#292c32',
            enabled: '#292c32',
            focused: '#292c32',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
          outline: '#292c32',
        },
        text: '#292c32',
        textLink: {
          disabled: {
            icon: '#292c32',
            text: '#292c32',
          },
          enabled: {
            icon: '#292c32',
            text: '#292c32',
          },
          focused: {
            icon: '#292c32',
            text: '#292c32',
          },
          hover: {
            icon: '#171b26',
            text: '#171b26',
          },
          outline: '#292c32',
          pressed: {
            icon: '#0c0f18',
            text: '#0c0f18',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    warning: {
      color: {
        background: '#f4c65a',
        border: 'rgba(255,255,255,0)',
        icon: '#292c32',
        iconButton: {
          background: {
            disabled: 'rgba(212,213,216,0)',
            enabled: 'rgba(212,213,216,0)',
            focused: 'rgba(212,213,216,0)',
            hover: 'rgba(212,213,216,0.08)',
            pressed: 'rgba(212,213,216,0.16)',
          },
          icon: {
            disabled: '#e2e2e4',
            enabled: '#e2e2e4',
            focused: '#e2e2e4',
            hover: '#efeff0',
            pressed: '#fcfcfd',
          },
          outline: '#e2e2e4',
        },
        text: '#292c32',
        textLink: {
          disabled: {
            icon: '#e2e2e4',
            text: '#e2e2e4',
          },
          enabled: {
            icon: '#e2e2e4',
            text: '#e2e2e4',
          },
          focused: {
            icon: '#e2e2e4',
            text: '#e2e2e4',
          },
          hover: {
            icon: '#fcfcfd',
            text: '#efeff0',
          },
          outline: '#e2e2e4',
          pressed: {
            icon: '#fcfcfd',
            text: '#fcfcfd',
          },
        },
      },
      radius: '12px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
  },
  toggleButton: {
    default: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(125,205,232,0.48)',
              enabled: '#7dcde8',
              focus: '#b2e4f5',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
            icon: {
              disabled: 'rgba(41,44,50,0.48)',
              enabled: '#292c32',
              focus: '#171b26',
              hover: '#171b26',
              pressed: '#0c0f18',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(125,205,232,0)',
              enabled: 'rgba(125,205,232,0)',
              focus: 'rgba(125,205,232,0.08)',
              hover: 'rgba(125,205,232,0.08)',
              pressed: 'rgba(125,205,232,0.16)',
            },
            border: {
              disabled: 'rgba(97,99,107,0.48)',
              enabled: '#61636b',
              focus: '#484a51',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
            icon: {
              disabled: 'rgba(212,213,216,0.48)',
              enabled: '#d4d5d8',
              focus: '#e2e2e4',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(125,205,232,0)',
            enabled: 'rgba(125,205,232,0)',
            focus: 'rgba(125,205,232,0.08)',
            hover: 'rgba(125,205,232,0.08)',
            pressed: 'rgba(125,205,232,0.16)',
          },
          icon: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#e2e2e4',
            hover: '#e2e2e4',
            pressed: '#efeff0',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    inverse: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(125,205,232,0.48)',
              enabled: '#7dcde8',
              focus: '#b2e4f5',
              hover: '#b2e4f5',
              pressed: '#f1fbfe',
            },
            icon: {
              disabled: 'rgba(41,44,50,0.48)',
              enabled: '#292c32',
              focus: '#171b26',
              hover: '#171b26',
              pressed: '#0c0f18',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(41,44,50,0)',
              enabled: 'rgba(41,44,50,0)',
              focus: 'rgba(41,44,50,0.08)',
              hover: 'rgba(41,44,50,0.08)',
              pressed: 'rgba(41,44,50,0.16)',
            },
            border: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#292c32',
              pressed: '#383b42',
            },
            icon: {
              disabled: 'rgba(41,44,50,0.48)',
              enabled: '#292c32',
              focus: '#171b26',
              hover: '#292c32',
              pressed: '#383b42',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(41,44,50,0)',
            enabled: 'rgba(41,44,50,0)',
            focus: 'rgba(41,44,50,0.08)',
            hover: 'rgba(41,44,50,0.08)',
            pressed: 'rgba(41,44,50,0.16)',
          },
          icon: {
            disabled: 'rgba(41,44,50,0.48)',
            enabled: '#292c32',
            focus: '#171b26',
            hover: '#171b26',
            pressed: '#0c0f18',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '40px',
          width: '40px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  tooltip: {
    default: {
      color: {
        background: '#e2e2e4',
        border: '#d4d5d8',
        default: {
          background: {
            primary: '#000000',
            secondary: '#292c32',
          },
          border: {
            secondary: '#61636b',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#e2e2e4',
            },
          },
        },
        text: '#292c32',
        title: {
          background: {
            primary: '#000000',
            secondary: '#292c32',
          },
          border: {
            secondary: '#61636b',
          },
          label: {
            subtitle: {
              primary: '#292c32',
              secondary: '#e2e2e4',
            },
            title: {
              primary: '#292c32',
              secondary: '#e2e2e4',
            },
          },
        },
      },
      radius: {
        radius: '12px',
      },
      sizing: {
        default: {
          min: {
            height: '24px',
            width: '24px',
          },
        },
        max: '480px',
        min: '40px',
        title: {
          min: {
            height: '64px',
            width: '48px',
          },
        },
      },
      spacing: {
        Number: '0',
        default: {
          bottom: '0',
          left: '8px',
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
          right: '8px',
          top: '0',
        },
        title: {
          bottom: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    inverse: {
      color: {
        background: '#292c32',
        border: '#292c32',
        text: '#e2e2e4',
        title: {
          label: {
            subtitle: {
              primary: '#292c32',
            },
            title: {
              primary: '#292c32',
            },
          },
        },
      },
      radius: {
        radius: '12px',
      },
      sizing: {
        max: '480px',
        min: '40px',
      },
      spacing: {
        default: {
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  treeView: {
    default: {
      color: {
        richHeader: '#0c0f18',
        selected: {
          background: {
            disabled: 'rgba(15,69,87,0.48)',
            enabled: '#0f4557',
            focus: '#0f4557',
            hover: '#002d47',
            pressed: '#041116',
          },
          border: {
            disabled: 'rgba(125,205,232,0.48)',
            enabled: '#7dcde8',
            focus: '#7dcde8',
            hover: '#b2e4f5',
            pressed: '#f1fbfe',
          },
        },
        text: {
          subtitle: {
            disabled: 'rgba(212,213,216,0.48)',
            enabled: '#d4d5d8',
            focus: '#d4d5d8',
            hover: '#e2e2e4',
            pressed: '#efeff0',
          },
          title: {
            disabled: 'rgba(226,226,228,0.48)',
            enabled: '#e2e2e4',
            focus: '#e2e2e4',
            hover: '#efeff0',
            hyperlink: '#7dcde8',
            pressed: '#fcfcfd',
          },
        },
        unselected: {
          background: {
            disabled: 'rgba(23,27,38,0.48)',
            enabled: '#292c32',
            focus: '#292c32',
            hover: '#171b26',
            pressed: '#292c32',
          },
          border: {
            enabled: '#292c32',
          },
        },
      },
      padding: {
        small: {
          child: {
            bottom: '8px',
            gap: '8px',
            left: '48px',
            right: '24px',
            top: '8px',
          },
          parent: {
            bottom: '8px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '8px',
          },
        },
        standard: {
          child: {
            bottom: '12px',
            gap: '8px',
            left: '52px',
            right: '24px',
            top: '12px',
          },
          parent: {
            bottom: '12px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '12px',
          },
        },
      },
      radius: '0',
    },
  },
  typography: {
    default: {
      color: {
        default: {
          accent: '#03b3c9',
          brand: '#7dcde8',
          danger: '#ff9999',
          decorative1: '#e5f0ff',
          decorative2: '#fff4e5',
          decorative3: '#faeaf7',
          decorative4: '#e5f8ff',
          decorative5: '#e5fffd',
          neutral: '#e2e2e4',
          success: '#99ffaa',
          warning: '#f4c65a',
        },
        inverse: {
          accent: '#027285',
          brand: '#0f4557',
          danger: '#990000',
          decorative1: '#004199',
          decorative2: '#995900',
          decorative3: '#7c1d68',
          decorative4: '#004a66',
          decorative5: '#004d48',
          neutral: '#292c32',
          success: '#005e0f',
          warning: '#3b2a02',
        },
      },
      sizing: {
        icon: {
          lineHeight: {
            bodyDefault: '24px',
            bodySmall: '21px',
            caption: '20px',
            headline: '53px',
            subheadline: '35px',
            subtitle: '30px',
            title: '36px',
          },
        },
      },
      spacing: {
        gap: {
          bodyDefault: '8px',
          bodySmall: '4px',
          caption: '4px',
          headline: '12px',
          subheadline: '8px',
          subtitle: '8px',
          title: '8px',
        },
      },
    },
    font: {
      fallback: 'Noto Sans, Nunito Sans, Arial, sans-serif',
      family: 'Noto Sans',
      size: {
        '2x': '24px',
        '3x': '28px',
        '4x': '32px',
        '5x': '36px',
        '6x': '40px',
        '7x': '48px',
        '8x': '60px',
        base: '16px',
        lg: '18px',
        sm: '14px',
        xl: '20px',
        xs: '13px',
      },
      weight: {
        black: 900,
        bold: 700,
        heavy: 800,
        light: 300,
        medium: 500,
        regular: 400,
        semibold: 600,
        thin: 200,
      },
    },
    lineHeight: {
      '2x': '35px',
      '3x': '36px',
      '4x': '42px',
      '5x': '48px',
      '6x': '53px',
      '7x': '60px',
      '8x': '72px',
      base: '24px',
      lg: '27px',
      sm: '21px',
      xl: '30px',
      xs: '20px',
    },
    spacing: {
      letter: {
        '2x': '0.48px',
        '3x': '0.80px',
        '4x': '1.00px',
        '5x': '1.20px',
        '6x': '1.40px',
        base: '0.32px',
        lg: '0.32px',
        md: '0.28px',
        negative: {
          lg: '-0.48px',
          md: '-0.32px',
          sm: '-0.26px',
          xl: '-1.00px',
        },
        none: '0',
        sm: '0.26px',
        xl: '0.40px',
      },
      paragraph: {
        '2x': '52.80px',
        '3x': '54.00px',
        '4x': '63.00px',
        '5x': '72.00px',
        '6x': '79.20px',
        '7x': '90.00px',
        '8x': '108.00px',
        base: '36.00px',
        lg: '40.50px',
        none: '0',
        sm: '31.50px',
        xl: '45.00px',
        xs: '29.25px',
      },
    },
  },
  videoPlayer: {
    default: {
      radius: {
        container: '0',
        focus: '0',
      },
    },
  },
};
